import { FC } from "react";
import styles from "./Header.module.css";
import { SaleDb } from "../../models/sale.db";
interface PropTypes {
  sale: SaleDb | null;
  logoUrl: string;
  onClick: () => void;
  isMobile: boolean;
}

const Header: FC<PropTypes> = ({
  sale,
  logoUrl: photoURL,
  onClick,
  isMobile,
}) => {
  const logoWidth = isMobile ? 139 : 270;
  const logoHeight = isMobile ? 31 : 68;
  return (
    <div className={styles.header}>
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "start" : "center",
        }}
      >
        <div style={{ width: logoWidth, height: logoHeight }}>
          <img
            src={photoURL}
            width={logoWidth}
            height={logoHeight}
            alt="logo"
          />
        </div>
        <div
          className={styles.slogan}
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: isMobile ? 0 : 20,
            paddingTop: isMobile ? 12 : 0,
          }}
        >
          <div style={{ fontFamily: "Roobert", fontSize: isMobile ? 20 : 36 }}>
            {sale?.name}
          </div>
          <div style={{ fontFamily: "Roobert", fontSize: isMobile ? 12 : 18 }}>
            {sale?.desription.replaceAll("\n", " | ")}
          </div>
        </div>
      </div>
      {isMobile ? null : (
        <div className={styles.headerBtn} onClick={onClick}>
          <div className={styles.textBtn}>RSVP TO ATTEND</div>
        </div>
      )}
    </div>
  );
};
export default Header;
